<script setup>
import { computed } from 'vue'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { getSignteqSignatureUrl } from '../../../utilities/api'
import { onMounted } from 'vue'
import { onUnmounted } from 'vue'
import { ref } from 'vue'
import { storeSignteqSignaturedDocument } from '../../../utilities/api'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'

import InvestmentProcessNavigationButtons from '../InvestmentProcessNavigationButtons.vue'
import LoadingSpinner from '../../base/LoadingSpinner.vue'

const iFrameHeight = ref('600px')
const isLoading = ref(true)
const isSuccess = ref(false)
const order_uid = computed(() => useInvestmentProcessDataState().createdOrder.order_uid)
const verificationLink = ref(false)

async function fetchSignteqSignatureUrl() {
    const response = await getSignteqSignatureUrl(order_uid.value)
    if (response.status === 200) {
        verificationLink.value = response.data.redirect_url
    }
    isLoading.value = false
}

async function checkMessage(message) {
    if (message.data.type === 'COMPLETED' && message.data.data.document) {
        await storeSignteqSignaturedDocument(message.data.data.document, order_uid.value).then(() => {
            isSuccess.value = true
        })
    }
}

onMounted(() => {
    fetchSignteqSignatureUrl()
    window.addEventListener('message', checkMessage)
})

onUnmounted(() => {
    window.removeEventListener('message', checkMessage)
})
</script>
<template>
    <div class="px-4 py-6 sm:p-6 lg:p-8">
        <div>
            <h3 class="pb-3 text-base font-bold text-gray-700">Signteq {{ $t('investment_process.signature') }}</h3>
            <p
                v-if="getCampaignData().asset_data.signature_legal_notice"
                class="mb-3 border border-gray-200 p-2 font-medium text-gray-500"
                v-html="getCampaignData().asset_data.signature_legal_notice"></p>

            <div
                v-if="isLoading"
                class="align-items-center flex justify-center border border-gray-200"
                :style="`height: ${iFrameHeight}`">
                <LoadingSpinner v-if="isLoading" class="h-10 w-10 fill-primary" />
            </div>

            <iframe
                v-if="verificationLink"
                class="w-full border border-gray-200 pt-8"
                :style="`height: ${iFrameHeight};`"
                :src="verificationLink"
                title="Signteq signature" />
        </div>
        <InvestmentProcessNavigationButtons
            :next-button-disabled="!isSuccess"
            :next-button-text="$t('investment_process.confirm_signature')" />
    </div>
</template>
